module.exports = __webpack_public_path__ + "img/hwdl11.4a039689.png";